export default __webpack_public_path__ + "static/media/door-connected.7801b521.svg";